import CustomAsyncMultiSelect from "./custom-async-multi-select.component";

export default CustomAsyncMultiSelect;
